<template>
  <section>
    <div v-if="loading" class="info">{{ $t('common.loading') }}</div>
    <div v-else-if="error" class="error">{{ error }}</div>

    <template v-else>
      <div class="detail">
        <h3>{{ expert.name }}</h3>
        <p>{{ $t('randevu.experts.detail.email_label') }}   <strong>{{ expert.email  || '-' }}</strong></p>
        <p>{{ $t('randevu.experts.detail.phone_label') }} <strong>{{ expert.phone  || '-' }}</strong></p>
      </div>

      <h4>{{ $t('randevu.experts.detail.appointments_title') }}</h4>
      <ul class="list">
        <li v-for="a in appts" :key="a.id">
          {{ fmtDate(a.start_time) }} – <strong>{{ a.customer_name }}</strong>
          <small>({{ a.status }})</small>
          <ul class="svc">
            <li v-for="s in a.services" :key="s.service_id">
              {{ s.service_name }} ×{{ s.quantity }}
            </li>
          </ul>
        </li>
        <li v-if="!appts.length">{{ $t('randevu.experts.detail.empty') }}</li>
      </ul>
    </template>
  </section>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t } = useI18n();

const props    = defineProps({ expertId: { type:Number, required:true } });
const expert   = ref({});
const appts    = ref([]);
const loading  = ref(false);
const error    = ref(null);

const fetch = async () => {
  loading.value = true;
  error.value   = null;
  try {
    const { data } = await axios.get(`/promo/user/experts/${props.expertId}/appointments`);
    expert.value = { name:data.expert_name }; // sadece ad dönüyor
    appts.value  = data.appointments;
  } catch {
    error.value = t("randevu.experts.detail.fetch_error");
  } finally {
    loading.value = false;
  }
};
const fmtDate = iso => iso.replace("T"," ").slice(0,16); // YYYY-MM-DD HH:MM

onMounted(fetch);
watch(()=>props.expertId, fetch);
</script>

<style scoped>
.detail { display:flex; flex-direction:column; gap:8px; margin-bottom:1rem; }
.list   { margin:0; padding:0; list-style:none; padding: 1em; max-height: 350px; overflow: auto;}
.list>li{ margin:.4rem 0; }
.svc    { margin:.2rem 0 .4rem 2rem; list-style:square; font-size:.9em; }
h3,h4{ font-weight:400; margin:.2rem 0; }
.info,.error{ margin-top:.6rem; }
.error{ color:#f44336; }
p{margin: 5px 0;}
</style>
